import React from "react";

export default function MSAccess_Round() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Round</h1>
      <p>This is the MSAccess_Round component generated from the SQL JSON.</p>
    </div>
  );
}
